// Keep preloading and both render paths on the same split point.
export const importAgentSection = async (): Promise<typeof import('./agent-section')> =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-chat-prompt-input/agent-section" */ './agent-section'
	);
